import { render, staticRenderFns } from "./DispatchImportList.vue?vue&type=template&id=36bfcb22&"
import script from "./DispatchImportList.vue?vue&type=script&lang=js&"
export * from "./DispatchImportList.vue?vue&type=script&lang=js&"
import style0 from "./DispatchImportList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports